<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="file in files" :key="file.id">
          <td class="pl-0">
            <strong>{{ file.originalName }}</strong>
          </td>
          <td>&#183;{{ fileExtension(file) }}</td>
          <td>{{ new Date(file.timestamp.created).toISOString() | simpleDoubleDigitDate }}</td>
          <td v-if="!isFileInRefs(file)">
            <v-btn icon>
              <v-icon @click="removeFile(file)" color="grey lighten-1">mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script lang="ts">
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ThgChargingStationProofDocumentDtoGen,
  ThgChargingStationDocumentTypeDtoGen
} from "@/services/thg/v1/data-contracts";

@Component({
  components: {},
  filters: { simpleDoubleDigitDate }
})
export default class ThgChargingStationProofDocumentTable extends Vue {
  @Prop()
  files!: ThgChargingStationProofDocumentDtoGen[];
  @Prop()
  refs!: ThgChargingStationDocumentTypeDtoGen[];

  isFileInRefs(file: ThgChargingStationProofDocumentDtoGen) {
    return this.refs.find((ref) => ref.refId === file.id);
  }

  fileExtension(file: ThgChargingStationProofDocumentDtoGen) {
    return file.name.split(".")[1];
  }

  removeFile(file: ThgChargingStationProofDocumentDtoGen) {
    this.$emit("file-removed", file);
  }
}
</script>
<style scoped>
td {
  padding-left: 0;
}
</style>
